var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    card: true,
    'card--padding': !_vm.noPadding,
  }},[_vm._t("header"),_c('div',{staticClass:"card__sub-header"},[_c('h3',{staticClass:"card__title h2",class:{ 'card__title--span': !_vm.hasSideContent },style:(_vm.titleContainerStyle)},[_vm._t("title")],2),_vm._t("side-content")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }